import React from 'react';
import { Image } from '../../components/Image';
import {
  fontBody,
  fontBodyMiniMedium,
  fontHeading3,
} from '../../styles/typographyNew';
import { classNames } from '../../utils/style';

interface CarouselCardProps {
  isCounter?: boolean;
  title?: string;
  description?: string;
  image?: any;
  cardIndex: number;
}

export const CarouselCard: React.FC<CarouselCardProps> = ({
  cardIndex,
  isCounter,
  title,
  description,
  image,
}) => {
  return (
    <div
      draggable={false}
      className={classNames(
        'flex flex-col justify-between',
        'h-[500px] w-[320px] md:h-[600px] md:w-[417px]',
        'rounded-[24px] bg-[#F7F9FC]',
        'xl:border-none',
      )}
    >
      <div className="flex flex-col items-start p-24 md:p-40">
        {isCounter && (
          <div
            className={classNames(
              'mb-16 bg-white shadow-tagRound',
              'flex h-[34px] w-[34px] items-center justify-center',
              'rounded-full text-[#0F6FDE]',
              fontBodyMiniMedium,
            )}
          >
            {cardIndex + 1}
          </div>
        )}
        {title && (
          <h3 className={classNames(fontHeading3, 'mb-12 text-[#011F40]')}>
            {title}
          </h3>
        )}
        {description && (
          <p className={classNames(fontBody, 'text-[#364A61]')}>
            {description}
          </p>
        )}
      </div>
      <div className={classNames('overflow-hidden rounded-b-[24px]')}>
        {image && (
          <Image
            {...image}
            draggable={false}
            pixelDensity={image.pixelDensity || 'image_with_text'}
            sizes={[
              '(max-width: 767px) 320px',
              '(max-width: 1279px) 417px',
              '(min-width: 1280px) 417px',
              '800px',
            ]}
          />
        )}
      </div>
    </div>
  );
};
